/* src/app/manual-adjustment/manual-adjustment-feature/manual-adjustment-feature.component.scss */
/*# sourceMappingURL=manual-adjustment-feature.component.css.map */
